var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3849 15.1465L13.2738 18.1465L19.0516 12.1465M14.7183 1.64648L17.4773 4.45369L21.2183 3.45514L22.2559 7.31881L25.9766 8.39648L25.015 12.2813L27.7183 15.1465L25.015 18.0116L25.9766 21.8965L22.2559 22.9741L21.2183 26.8378L17.4773 25.8392L14.7183 28.6465L11.9592 25.8392L8.21826 26.8378L7.1805 22.9741L3.45993 21.8965L4.4215 18.0116L1.71826 15.1465L4.4215 12.2813L3.45993 8.39648L7.1805 7.31881L8.21826 3.45514L11.9592 4.45369L14.7183 1.64648Z",
    fill: "#224173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3849 15.1465L13.2738 18.1465L19.0516 12.1465M14.7183 1.64648L17.4773 4.45369L21.2183 3.45514L22.2559 7.31881L25.9766 8.39648L25.015 12.2813L27.7183 15.1465L25.015 18.0116L25.9766 21.8965L22.2559 22.9741L21.2183 26.8378L17.4773 25.8392L14.7183 28.6465L11.9592 25.8392L8.21826 26.8378L7.1805 22.9741L3.45993 21.8965L4.4215 18.0116L1.71826 15.1465L4.4215 12.2813L3.45993 8.39648L7.1805 7.31881L8.21826 3.45514L11.9592 4.45369L14.7183 1.64648Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.d49d58fafc48ca2a71d42b8d9a1d80b5.svg";
export { ForwardRef as ReactComponent };